// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"33":"e0b77254","163":"a47421ac","165":"4f049560","362":"3d71fa22","381":"2d5cb3bf","414":"a07be48d","616":"2b54c207","661":"b67f2183","724":"0ffa91da","883":"8d776420"}[chunkId] + ".js";
};